/**
 * Route for `igaming-admin-fees-deduction-from-ngr`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingAdminFeesDeductionFromNgrPage } from "../features/igaming-admin-fees-deduction-from-ngr/IgamingAdminFeesDeductionFromNgrPage";

export const igamingAdminFeesDeductionFromNgrRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-admin-fees-deduction-from-ngr",
	component: IgamingAdminFeesDeductionFromNgrPage,
});

export default igamingAdminFeesDeductionFromNgrRoute;
